import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMembersComponent implements OnInit {
    public users: any[] = [];
    public loading: boolean = true;
    public search: string = '';
    public showDeleteModal: boolean = false;
    public deleteTarget: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('list', { text: this.search });
        if (code === 200) {
            this.users = data || [];
        }
        this.loading = false;
        await this.service.render();
    }

    public async toggleRole(user: any) {
        const newRole = user.role === 'admin' ? 'user' : 'admin';
        const { code } = await wiz.call('update_role', { id: user.id, role: newRole });
        if (code === 200) {
            user.role = newRole;
            await this.service.render();
        }
    }

    public openDelete(user: any) {
        this.deleteTarget = user;
        this.showDeleteModal = true;
    }

    public async confirmDelete() {
        if (!this.deleteTarget) return;
        const { code } = await wiz.call('delete', { id: this.deleteTarget.id });
        if (code === 200) {
            this.showDeleteModal = false;
            this.deleteTarget = null;
            await this.load();
        }
        await this.service.render();
    }

    public roleLabel(role: string): string {
        const map: any = { admin: '관리자', user: '사용자', expert: '전문가' };
        return map[role] || role;
    }

    public get currentUserId(): string {
        return this.service.auth.session?.id || '';
    }
}

export default PageMembersComponent;